import React from "react";
import { useParams } from "react-router-dom";
import {
  apiCallPost,
  calculateCost,
  indianRupee,
  niceDate,
  niceDateTime,
  renderQuantityNice,
} from "../util/util";
import "../Order.css";
import QRCode from "react-qr-code";
import { Button, H4, NonIdealState, Spinner } from "@blueprintjs/core";
import cogoToast from "cogo-toast";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class PHLowerOrder extends React.Component {
  state = {
    isLoading: true,
    isFailure: false,
    orderId: null,
    hasLoaded: false,
  };
  componentDidMount() {
    let ss = this.props.params.orderId;
    this.setState({ orderId: ss });
    if (ss) {
      this.getSubmission(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getSubmission = async (ss) => {
    try {
      let res = await apiCallPost("/print/ims2PharmaBill", {
        _id: ss,
      });
      this.setState({ isLoading: false, hasLoaded: true, ...res }, () => {
        document.title = `${this.state.customerName} - ${this.state.entityName}`;
      });
    } catch (err) {
      cogoToast.error("Failed to load pharmacy order data.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };

  renderHeader = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                alt="Client Logo"
                src={this.state.branchInfo.logoUrl}
                height="85px"
                width="auto"
                className="img_block"
              />
              <b
                style={{
                  fontSize: "9pt",
                  marginTop: "3px",
                  maxWidth: "120px",
                  textAlign: "center",
                }}
              >
                {this.state.branchInfo.hospital_name}
              </b>
            </div>
            <div>
              <div style={{ textAlign: "left" }}>
                {this.renderHorizontalText("PHARMACY INVOICE")}
              </div>
              <b>
                {this.state.branchInfo.rxRenderOptions.pharmacyName ||
                  this.state.branchInfo.hospital_contact[0]}
              </b>
              <br />
              {this.state.branchInfo.hospital_contact[1]} <br />
              {this.state.branchInfo.hospital_contact[2]} <br />
              {this.state.branchInfo.hospital_contact[3]} <br />
              {this.state.branchInfo.rxRenderOptions.pharmacyDLNo ? (
                <>
                  DL No:
                  {this.state.branchInfo.rxRenderOptions.pharmacyDLNo || ""}
                  <br />
                </>
              ) : null}
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              textAlign: "right",
              marginRight: "10px",
            }}
          >
            <div
              style={{
                marginLeft: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "space-between",
                textAlign: "right",
                maxWidth: "200px",
              }}
            >
              <div>
                <H4>{this.state.entityName}</H4>
              </div>
              <div>
                {niceDateTime(this.state.updatedAt)}
                <br />
                {this.state.customerName} <br /> {this.state.customerPID}
                <br />
                {this.state.customerPhone}
                <br />
                {this.state.customerAddress}
              </div>
            </div>
            <div
              style={{
                marginLeft: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <QRCode
                size={80}
                value={`https://print.newchart.care/pharmacy/${this.props.params.orderId}`}
                level="H"
              />
              <div
                style={{
                  fontSize: "x-small",
                  wordBreak: "break-all",
                  maxWidth: "150px",
                  textAlign: "center",
                }}
              >
                <code> {this.state.orderId}</code>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderItems = () => {
    return (
      <div>
        <div>{this.renderHorizontalText("ITEMS")}</div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Item</th>
              <th>Price</th>
              <th>GST</th>
              <th>Batch/Serial</th>
              <th>Expiry Date</th>
              <th>Quantity</th>
              <th>Pre-Tax Total</th>
              <th>Add GST</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>{this.renderEachItem()}</tbody>
          <tfoot>
            <tr>
              <td colSpan={9} style={{ textAlign: "right" }}>
                <b> Total</b>
              </td>
              <td>
                <b>{indianRupee(this.renderTotal())}</b>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  };
  renderEachItem = () => {
    if (!this.state.items) {
      return null;
    }
    if (!this.state.items.length) {
      return null;
    }
    return this.state.items.map((each, index) => {
      return (
        <tr>
          <td>{index + 1}</td>
          <td>{each.itemName}</td>
          <td>
            {indianRupee(each.itemSalePrice)} Per {each.itemUnitName}
          </td>
          <td>{each.itemSalePriceGst}%</td>
          <td>{each.inventoryDetails.serialNumber}</td>
          <td>{niceDate(each.inventoryDetails.expiresOn)}</td>
          <td>
            {renderQuantityNice(
              each.inventoryDetails.quantity,
              each.inventoryDetails.subunitOfConsumption,
              each.itemUnitName,
              each.itemSubunitName
            )}
          </td>
          <td>
            {indianRupee(
              calculateCost(
                each.itemSalePrice,
                0,
                each.inventoryDetails.quantity,
                each.inventoryDetails.subunitOfConsumption
              )
            )}
          </td>
          <td>
            {indianRupee(
              calculateCost(
                each.itemSalePrice,
                each.itemSalePriceGst,
                each.inventoryDetails.quantity,
                each.inventoryDetails.subunitOfConsumption
              ) -
                calculateCost(
                  each.itemSalePrice,
                  0,
                  each.inventoryDetails.quantity,
                  each.inventoryDetails.subunitOfConsumption
                )
            )}
          </td>
          <td>
            {indianRupee(
              calculateCost(
                each.itemSalePrice,
                each.itemSalePriceGst,
                each.inventoryDetails.quantity,
                each.inventoryDetails.subunitOfConsumption
              )
            )}
          </td>
        </tr>
      );
    });
  };
  renderTotal = () => {
    let total = 0;
    if (!this.state.items) {
      return total;
    }
    if (!this.state.items.length) {
      return total;
    }
    for (var i = 0; i < this.state.items.length; i++) {
      let each = this.state.items[i];
      total += calculateCost(
        each.itemSalePrice,
        each.itemSalePriceGst,
        each.inventoryDetails.quantity,
        each.inventoryDetails.subunitOfConsumption
      );
    }
    return total;
  };
  renderTermsAndFooter = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div style={{ textAlign: "left" }}>
                Items once sold cannot be returned.
              </div>
            </div>
          </div>{" "}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                maxWidth: "40vw",
              }}
            >
              <div style={{ textAlign: "right" }}>
                {this.renderHorizontalText("E. & O. E.")}
              </div>
              <div style={{ textAlign: "right" }}>
                This is a computer generated invoice and does not require a
                signature.
              </div>
              <div style={{ textAlign: "right" }}>
                In case of queries, please reach out to us.
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    );
  };
  renderPayments = () => {
    return (
      <div>
        <div>{this.renderHorizontalText("LEDGER OF PAYMENTS")}</div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>Time</th>
              <th>Type</th>
              <th>Mode</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>{this.renderEachPayment()}</tbody>
        </table>
      </div>
    );
  };
  renderEachPayment = () => {
    if (!this.state.paymentHistory) {
      return null;
    }
    if (!this.state.paymentHistory.length) {
      return null;
    }
    return this.state.paymentHistory.map((each, index) => {
      return (
        <tr>
          <td>{niceDateTime(each.paidAt)}</td>
          <td>{each.paymentType}</td>
          <td>{each.paymentMode}</td>
          <td>{indianRupee(each.paidAmountPaise)}</td>
        </tr>
      );
    });
  };
  renderVerticalText = (text, isProminent = true) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          textOrientation: "upright",
          writingMode: "vertical-rl",
          marginRight: "10px",
          fontSize: "xx-small",
          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderHorizontalText = (text, isProminent = false) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "xx-small",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className="center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    if (!this.state.hasLoaded) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return (
      <div
        className="rx__container"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {" "}
        <style type="text/css" media="print">
          {" @page { size: A4 landscape !important; margin: 7mm !important;"}
        </style>
        <div>
          <div className="no__print">
            <Button
              icon="print"
              text="Print"
              onClick={() => {
                window.print();
              }}
              fill
            />{" "}
            <br />
            <br />
          </div>
          {this.renderHeader()}
          <hr />
          {this.renderItems()}
          <hr />
        </div>
        <div style={{ position: "fixed", bottom: "0", width: "100vw" }}>
          {this.renderPayments()}
          <hr />
          {this.renderTermsAndFooter()}
        </div>
      </div>
    );
  }
}

const Pharmacy = withRouter(PHLowerOrder);
export default Pharmacy;
